import React, { useState, useMemo } from 'react';
import { FilePlayerProvider } from '../FilePlayerContext';
import { useGetFilePlayerFilesQuery, useDeleteFilesMutation } from 'app/api/assetApi';
import { useGetAppConfigQuery } from 'app/api/mainApi';
import { getFilePlayerOptions } from '../filePlayerUtils';
import { useFileListState } from '../hooks/useFileListState';
import AppBody from 'app/components/layout/AppBody';
import TemplateShell2 from 'app/components/layout/TemplateShell2';
import { FilesTab } from './FilesTab';
import { FileSearchBox } from './FileSearchBox';
import { FilePlayerTabs } from './FilePlayerTabs';
import { FileActionBar } from './FileActionBar';
import { FileZipStatusNotice } from './FileZipStatusNotice';
import { FileMediaViewer } from './FileMediaViewer';

export const FilePlayerPage = () => {
  const [page, setPage] = useState(1);
  const filesQuery = useGetFilePlayerFilesQuery({ page });
  const appConfig = useGetAppConfigQuery().data;
  const currentUser = appConfig?.current_user;
  const allFiles = filesQuery.data?.pages?.flatMap((p) => p.items) || [];
  const hasMoreFiles = !!filesQuery.data?.pages.at(-1)?.nextPage;
  const [deletedFileIds, setDeletedFileIds] = useState(new Set());
  const allFilesState = useFileListState(allFiles, deletedFileIds);
  const deleteFilesMutation = useDeleteFilesMutation();
  const filePlayerOptions = useMemo(() => getFilePlayerOptions(), []);
  const [mediaItems, setMediaItems] = useState([]);
  const [mediaViewerOpen, setMediaViewerOpen] = useState(false);
  const [currentView, setCurrentView] = useState('all');
  const [groupBy, setGroupBy] = useState(null);
  const [filterBy, setFilterBy] = useState(null);

  const playItems = (items) => {
    const media = items.map((file) => ({
      id: file.id,
      type: file.contentType?.split('/')[0],
      src: file.largeUrl,
      publicPreviewable: true,
      advisorLogin: file.advisorLogin,
    }));

    if (media.length) {
      setMediaItems(media);
      setMediaViewerOpen(true);
    }
  };

  const markFilesDeleted = (ids) => {
    setDeletedFileIds((prev) => new Set([...prev, ...ids]));
  };

  const contextValue = {
    filesQuery,
    allFiles,
    hasMoreFiles,
    currentUser,
    page,
    setPage,
    markFilesDeleted,
    deletedFileIds,
    deleteFilesMutation,
    filePlayerOptions,
    mediaItems,
    setMediaItems,
    setMediaViewerOpen,
    playItems,
    currentView,
    setCurrentView,
    groupBy,
    setGroupBy,
    filterBy,
    setFilterBy,
  };

  return (
    <AppBody>
      <TemplateShell2 header="File Player" showBackArrow>
        <FilePlayerProvider value={contextValue}>
          <FileMediaViewer
            items={mediaItems}
            open={mediaViewerOpen}
            onClose={() => setMediaViewerOpen(false)}
          />
          <FileZipStatusNotice />
          <FileActionBar fileListState={allFilesState} />
          <FileSearchBox />
          <FilePlayerTabs />
          <FilesTab allFilesState={allFilesState} />
        </FilePlayerProvider>
      </TemplateShell2>
    </AppBody>
  );
};
